module.exports = __webpack_public_path__ + "static/img/title.6fbc44c9.jpg";